import {
  useGetPatientDiagnoses,
  useGetPatientEthnicity,
  useGetPatientGenderIdentity,
  useGetPatientRace,
  useGetPatientSex,
} from '_api';
import { useMemo } from 'react';

const usePatientForm = () => {
  const { data: diagnosesConstants, isFetched: patientConstantsIsFetched } =
    useGetPatientDiagnoses();
  const diagnosesOptions = useMemo(() => {
    if (diagnosesConstants != undefined && patientConstantsIsFetched) {
      return diagnosesConstants;
    } else return [];
  }, [diagnosesConstants]);

  const { data: ethnicityConstants, isFetched: ethnicityConstantsIsFetched } =
    useGetPatientEthnicity();
  const ethnicityOptions = useMemo(() => {
    if (ethnicityConstants != undefined && ethnicityConstantsIsFetched) {
      return ethnicityConstants;
    } else return [];
  }, [ethnicityConstants]);

  const { data: genderConstants, isFetched: genderConstantsIsFetched } =
    useGetPatientGenderIdentity();
  const genderOptions = useMemo(() => {
    if (genderConstants != undefined && genderConstantsIsFetched) {
      return genderConstants;
    } else return [];
  }, [genderConstants]);

  const { data: raceConstants, isFetched: raceConstantsIsFetched } = useGetPatientRace();
  const raceOptions = useMemo(() => {
    if (raceConstants != undefined && raceConstantsIsFetched) {
      return raceConstants;
    } else return [];
  }, [raceConstants]);

  const { data: sexConstants, isFetched: sexConstantsIsFetched } = useGetPatientSex();
  const sexOptions = useMemo(() => {
    if (sexConstants != undefined && sexConstantsIsFetched) {
      return sexConstants;
    } else return [];
  }, [sexConstants]);

  return {
    diagnosesOptions,
    ethnicityOptions,
    genderOptions,
    raceOptions,
    sexOptions,
  };
};

export default usePatientForm;
